import React from 'react';
import * as TFF from '@tff/types/tff';
import { MetaValue, SsrDetails } from '@tff/types/tff/tfa-amend-ancillary-service';

interface CostOverviewProps {
  ssrDisplayData?: {
    ssrsToAdd: { [paxId: string]: SsrDetails[] };
    includedSsrs: { [paxId: string]: SsrDetails[] };
    metaValues: {
      type: string;
      ancillaries: MetaValue[];
    }[];
  };
  flightDisplayData?: {
    Journeys: TFF.Journey[];
  };
  asrDisplayData?: {
    // TODO: ASRs ought to be displayed in the table
  };
}

const CostOverview: React.FC<CostOverviewProps> = ({ ssrDisplayData, flightDisplayData, asrDisplayData }) => {
  return <div></div>;
};

export default CostOverview;
